/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AccountStakingEventsInfo,
    AccountStakingEventsInfoFromJSON,
    AccountStakingEventsInfoFromJSONTyped,
    AccountStakingEventsInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface AccountStakingEventsResponse
 */
export interface AccountStakingEventsResponse {
    /**
     * 
     * @type {Array<AccountStakingEventsInfo>}
     * @memberof AccountStakingEventsResponse
     */
    list: Array<AccountStakingEventsInfo>;
    /**
     * 
     * @type {number}
     * @memberof AccountStakingEventsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStakingEventsResponse
     */
    size?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStakingEventsResponse
     */
    maxPage?: number;
    /**
     * 
     * @type {number}
     * @memberof AccountStakingEventsResponse
     */
    totalSize?: number;
}

export function AccountStakingEventsResponseFromJSON(json: any): AccountStakingEventsResponse {
    return AccountStakingEventsResponseFromJSONTyped(json, false);
}

export function AccountStakingEventsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountStakingEventsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(AccountStakingEventsInfoFromJSON)),
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'maxPage': !exists(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !exists(json, 'totalSize') ? undefined : json['totalSize'],
    };
}

export function AccountStakingEventsResponseToJSON(value?: AccountStakingEventsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(AccountStakingEventsInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize,
    };
}


